import React from 'react'
import MenuItem from './MenuItem'
import {Divider, Menu} from '@mui/material'
import {useLogoutMutation} from 'store/Store'
import {useNavigate} from 'react-router-dom'
import Settings from '@mui/icons-material/Settings'
import Logout from '@mui/icons-material/Logout'
import {useTranslation} from 'react-i18next'
import {useDispatch} from 'react-redux'
import baseApi from 'store/slices/api/baseApi'
const MenuProfile = ({anchorEl, isMenuOpen, handleMenuClose}) => {
    const [doLogout] = useLogoutMutation()
    const {t} = useTranslation()
    const dispatch = useDispatch()

    const navigate = useNavigate()

    const onClickSettings = () => navigate('/settings')

    const handleLogout = async () => {
        await doLogout().unwrap()
        dispatch(baseApi.util.resetApiState())
        navigate('/login', {replace: true})
    }

    return (
        <Menu
            anchorEl={anchorEl}
            keepMounted
            open={isMenuOpen}
            onClose={handleMenuClose}
            slotProps={{
                paper: {
                    elevation: 0,
                    sx: {
                        overflow: 'visible',
                        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                        mt: 1.5,
                        '& .MuiAvatar-root': {
                            width: 32,
                            height: 32,
                            ml: -0.5,
                            mr: 1,
                        },
                        '&::before': {
                            content: '""',
                            display: 'block',
                            position: 'absolute',
                            top: 0,
                            right: 14,
                            width: 10,
                            height: 10,
                            bgcolor: 'background.paper',
                            transform: 'translateY(-50%) rotate(45deg)',
                            zIndex: 0,
                        },
                    },
                },
            }}
            transformOrigin={{horizontal: 'right', vertical: 'top'}}
            anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}>
            <MenuItem
                onClick={onClickSettings}
                icon={<Settings fontSize="small" />}
                title={t('header.profile.settings')}
            />
            <Divider />
            {/* <MenuItem onClick={handleMenuClose} title={t('header.profile.myAccount')} /> */}
            <MenuItem
                onClick={handleLogout}
                icon={<Logout fontSize="small" />}
                title={t('header.profile.logout')}
            />
        </Menu>
    )
}

export default MenuProfile
